"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _react = _interopRequireDefault(require("react"));

var _gatsby = require("gatsby");

exports.onRenderBody = function (_ref, pluginOptions) {
  var setHeadComponents = _ref.setHeadComponents;

  // If icons were generated, also add a favicon link.
  if (pluginOptions.icon) {
    setHeadComponents([_react.default.createElement("link", {
      key: "gatsby-plugin-manifest-icon-link",
      rel: "shortcut icon",
      href: (0, _gatsby.withPrefix)("/icons/icon-48x48.png")
    })]);
  }

  setHeadComponents([_react.default.createElement("link", {
    key: "gatsby-plugin-manifest-link",
    rel: "manifest",
    href: (0, _gatsby.withPrefix)("/manifest.webmanifest")
  }), _react.default.createElement("meta", {
    key: "gatsby-plugin-manifest-meta",
    name: "theme-color",
    content: pluginOptions.theme_color
  })]);
};